// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__SHbe6","form":"Auth_form__bqYvT"};